module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "bodymatter",
      "title": "Acknowledgments"
    }
  }, [_c('header', [_c('h2', {
    staticClass: "chnum",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('em', [_vm._v("ACKNOWLEDGMENTS")])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Atlanta Review:")]), _vm._v(" “Oldguy: Superhero”; "), _c('em', [_vm._v("Black Renaissance Noir:")]), _vm._v(" “Oldguy: Superhero—The End?” (retitled “Oldguy: Superhero, Jumper”), “Oldguy: Superhero vs. His Nemesis (II)”; "), _c('em', [_vm._v("Epoch:")]), _vm._v(" “Oldguy: Superhero vs. His Nemesis”; "), _c('em', [_vm._v("Green Mountains Review:")]), _vm._v(" “Oldguy: Superhero’s Combat Moves,” “Oldguy: Superhero vs. His Nemesis (III),” “Oldguy: Superhero’s Last Will and Testament,” “Oldguy: Superhero Sings,” “Oldguy: Superhero, Noir,” “Oldguy: Superhero, Scoutmaster,” “Oldguy: Superhero vs. Magneto,” “Oldguy: Superhero Gets a Physical,” “Oldguy: Superhero Gives Away Professional Secrets,” “Oldguy: Superhero vs. The Blob,” “Oldguy: Superhero, Fashion Plate,” “Oldguy: Superhero Decides to Hang it Up,” “Oldguy: Superhero Attends the Associated Superheroes Conference,” “Oldguy: Superhero, Top Eliminator,” “Oldguy: Superhero, Homie,” “Oldguy: Superhero—His Utility Belt”; "), _c('em', [_vm._v("I-70 Review:")]), _vm._v(" “Oldguy: Superhero Bends an Elbow”; "), _c('em', [_vm._v("New Letters:")]), _vm._v(" “Oldguy: Superhero Discovers his Brother,” “Oldguy: Superhero—His Origin”; "), _c('em', [_vm._v("Plume:")]), _vm._v(" “Oldguy: Superhero, Undercover”; "), _c('em', [_vm._v("Rattle:")]), _vm._v(" “Oldguy: Superhero vs. The Riddler,” “Oldguy: Superhero, Associate,” “Oldguy: Superhero, Steady Hand”; and "), _c('em', [_vm._v("The American Journal of Poetry:")]), _vm._v(" “Oldguy: Superhero Takes His Driver’s Test.”")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-426bc60c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Ack.vue
// module id = 69
// module chunks = 0